import { createSlice } from '@reduxjs/toolkit';

interface InitState {
  number: number;
}

const initialState: InitState = {
  number: 0,
};

const botSlice = createSlice({
  name: 'bot',
  initialState,
  reducers: {},
});

export default botSlice.reducer;
